import { useEffect, useState } from "react"
import { analyteLaunchSkip } from "../../../../../../../services/ciq"
import useDataApi from "../../../../../../../hooks/useDataApi"
import { useParams } from "react-router-dom"
import { useAnalyte } from "../../context/analyte"

const fnMockRuns = (aRuns) => {
  if (aRuns?.length < 9) {
    const arr = Array.from({ length: 10 - aRuns.length }, () => ({
      eqpanltrun_number: "",
      eqpanltrun_launches: [],
      eqpanltrun_ddate: "",
      eqpanltrun_status: "",
    }))

    return [...aRuns, ...arr]
  }

  return aRuns
}

export function useTableAnalysis({ aRuns, anlt_nid, idx, pagination, setSelectedRun, selectedRun }) {
  const [oFetchRunRes, fnFetchRunReq] = useDataApi(analyteLaunchSkip)
  const analyteContext = useAnalyte()
  const [aTableData, setATableData] = useState([])

  const [selectedColumn, setSelectedColumn] = useState(null)
  const [selectedHeader, setSelectedHeader] = useState(null)
  const [limit, setLimit] = useState({ init: 0, final: 10 })

  const { id: equipmentId } = useParams()

  const launchAnalysis = analyteContext?.launchAnalysis
  const setLaunchAnalysis = analyteContext?.setLaunchAnalysis

  const handleCellClick = (columnIndex) => {
    if (!pagination) return

    setSelectedColumn(columnIndex)
    setSelectedHeader(columnIndex)
  }

  useEffect(() => {
    if (!aRuns.length) {
      // fill the table with mock runs
      setATableData(fnMockRuns([]))
      return
    }

    setATableData(fnMockRuns(aRuns))

    if (selectedRun) return

    const findLasIndex = () => {
      for (let i = aRuns.length - 1; i >= 0; i--) {
        if (aRuns[i].eqpanltrun_number !== "") {
          return i
        }
      }
      return -1
    }

    const lastRunSeleted = aRuns[findLasIndex()]

    setSelectedRun?.(lastRunSeleted)
    if (pagination) handleCellClick(findLasIndex())
  }, [aRuns, limit.init, limit.final, selectedRun])

  // update selected run mark
  useEffect(() => {
    if (!selectedRun || !aTableData?.length) return
    const aCurrentTableData = aTableData?.length
    ? aTableData.slice(limit.init, limit.final)
    : []
    const nSelectedRunIndex = aCurrentTableData.findIndex(
      (run) => run.eqpanltrun_nid === selectedRun?.eqpanltrun_nid)
      handleCellClick(nSelectedRunIndex)
  }, [selectedRun, aTableData, limit.init, limit.final])

  useEffect(() => {
    if (!launchAnalysis?.length) return

    const runsAnalyte = launchAnalysis[idx].anlt_runs

    if (runsAnalyte.length < 9) {
      const arr = Array.from({ length: 10 - runsAnalyte.length }, () => ({
        eqpanltrun_number: "",
        eqpanltrun_launches: [],
        eqpanltrun_ddate: "",
        eqpanltrun_status: "",
      }))

      const newDataAnalye = [...runsAnalyte, ...arr]

      setLaunchAnalysis(
        launchAnalysis.map((item) => {
          if (item.anlt_nid === anlt_nid) return { ...item, anlt_runs: newDataAnalye }

          return item
        }),
      )
    }
  }, [])

  const fetchRun = async (runNumber) => {
    await fnFetchRunReq(equipmentId, anlt_nid, runNumber, "prev")
  }

  useEffect(() => {
    if (!launchAnalysis?.length) return
    const runsAnalyte = launchAnalysis[idx].anlt_runs

    if (oFetchRunRes.data?.data) {
      const data = [oFetchRunRes.data?.data, ...runsAnalyte]

      setLaunchAnalysis(
        launchAnalysis.map((item, index) =>
          index === idx ? { ...item, anlt_runs: data } : item,
        ),
      )
    }
  }, [oFetchRunRes.data?.data])

  const sortedATableData = aTableData.sort((a, b) => {
    return !a.eqpanltrun_number || a.eqpanltrun_number - b.eqpanltrun_number
  })

  return {
    aTableData: sortedATableData,
    selectedColumn,
    selectedHeader,
    oFetchRunRes,
    setLimit,
    limit,
    handleCellClick,
    fetchRun,
  }
}
